export const formatDate = (
  dateString: string | number,
  ...rest: Parameters<Date['toLocaleDateString']>
) => new Date(dateString).toLocaleDateString(...rest);
